import { defineStore } from "pinia";

export const useArticleStore = defineStore({
  id: "article",
  state: () => ({
    tagList: [], // 标签
    searchTag: {
      // 搜索标签
      text: "",
      id: "",
    },
    articlePageSize: 20, // 文章分页大小
  }),
  actions: {
    setTagList(tagList) {
      this.tagList = tagList;
    },
    setSeatchTag(info) {
      this.searchTag.text = info.text;
      this.searchTag.id = info.id;
    },
    setArticlePageSize(size) {
      this.articlePageSize = size;
    },
  },
});
